import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  AfterViewInit,
  HostListener,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogContent,
  MatDialogActions,
} from "@angular/material/dialog";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { EmpleadoService } from "src/app/empleado/empleado.service";
import { UtileriasService } from "src/app/utilerias/service/utilerias.service";
import { AuthService } from "src/app/security/auth.service";
import { EvidenciaViewerService } from "src/app/shared/services/evidencia-viewer.service";
import { GenericoService } from "src/app/shared/services/generico.service";
import { Router } from "@angular/router";
import { TareaDiaria } from "src/app/shared/model/tarea/tareaDiaria.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { EvidenciaBean } from "src/app/shared/model/incidencias/evidenciaBean.model";
import swal from "sweetalert2";
import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { IncidenciasService } from "src/app/incidencias/incidencias.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ModalTareaAnteriorComponent } from "./modal-tarea-anterior/modal-tarea-anterior.component";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { NgFor, NgClass, NgIf, DatePipe } from "@angular/common";
import { MatChip } from "@angular/material/chips";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-modal-detalle-proyeccion",
  standalone: true,
  templateUrl: "./modal-detalle-proyeccion.component.html",
  styleUrls: ["./modal-detalle-proyeccion.component.css"],
  imports: [
    MatIconButton,
    MatIcon,
    MatButton,
    MatDialogContent,
    NgFor,
    MatChip,
    NgClass,
    NgIf,
    DatePipe,
  ],
})
export class ModalDetalleProyeccionComponent implements OnInit {
  tarea: TareaDiaria = new TareaDiaria();
  proyectos: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private proyectosService: ProyectosService,
    private empleadosService: EmpleadoService,
    private generico: GenericoService,
    private utilerias: UtileriasService,
    private authS: AuthService,
    private router: Router,
    private incidenciaService: IncidenciasService,
    private modal: MatDialog,
    private visorEvidencias: EvidenciaViewerService,
    private sanitizer: DomSanitizer,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getDetalleProyeccion(this.data);
  }

  getDetalleProyeccion(data: any) {
    this.tarea.idUsuario = data.idUsuario;
    this.tarea.idProyecto = data.idProyecto;
    this.tarea.idCliente = data.idCliente;
    this.tarea.idArea = data.idArea;
    this.tarea.fecha_inicio = data.fecha;
    this.tarea.fecha_fin = data.fecha;

    firstValueFrom(
      this.generico.obtenerElementoPorCampoPost(
        UrlConstantes.DETALLE_PROYECCION,
        this.tarea
      )
    )
      .then((res: any) => {
        this.proyectos = Array.isArray(res) ? res : res ? [res] : [];
        this.changeDetectorRef.detectChanges();
      })
      .catch(() => {
        this.proyectos = [];
        this.changeDetectorRef.detectChanges();
      });
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  evidenciaBean: EvidenciaBean = new EvidenciaBean();
  consultaImagenEvidencia(idProyecto, value: any) {
    this.evidenciaBean.idProyecto = idProyecto;
    this.evidenciaBean.idTarea = value.id_tarea ?? value.id;
    this.evidenciaBean.nombre = value.nombreArchivo;

    if (this.visorEvidencias.esImagen(this.evidenciaBean.nombre)) {
      this.muestraImagen(this.evidenciaBean);
      return;
    }

    if (this.visorEvidencias.esVideo(this.evidenciaBean.nombre)) {
      this.muestraVideo(this.evidenciaBean);
      return;
    }

    // Excel, PDF, Word, comprimidos, etc. no se pueden previsualizar:
    // se entregan directamente al usuario como descarga.
    this.descargaEvidencia(idProyecto, value);
  }

  muestraImagen(evidencia: EvidenciaBean) {
    this.incidenciaService.condultaImagenEvidencia(evidencia).subscribe({
      next: (res) => this.visorEvidencias.abreImagen(evidencia.nombre, res),
      error: () => this.visorEvidencias.avisoNoDisponible(),
    });
  }

  muestraVideo(evidencia: EvidenciaBean) {
    firstValueFrom(
      this.generico.consultaVideoEvidencia(
        UrlConstantes.consultaVideoEvidencia,
        evidencia
      )
    )
      .then((res) => this.visorEvidencias.abreVideo(evidencia.nombre, res))
      .catch(() => this.visorEvidencias.avisoNoDisponible());
  }

  fileUrl: any;
  @ViewChild("downloadFile") private downloadFile: ElementRef;

  descargaEvidencia(idProyecto: any, value: any) {
    firstValueFrom(
      this.generico.descargaEvidencia(
        UrlConstantes.descargaEvidencia,
        "TAREA",
        idProyecto,
        value.id_tarea ?? value.id,
        value.nombreArchivo
      )
    )
      .then((res) => this.visorEvidencias.descarga(value.nombreArchivo, res))
      .catch(() => this.visorEvidencias.avisoNoDisponible());
  }

  /**
   * Alta (tarea null) o modificación de una tarea anterior del colaborador.
   * nombreProyecto deja ver el proyecto de la tarea aunque ya no esté vigente.
   */
  agregarEditar(tarea, nombreProyecto?: string) {
    let fechaTarea = this.data.fecha;
    let idUsuario = this.data.idUsuario;
    let dialogRef = this.modal.open(ModalTareaAnteriorComponent, {
      disableClose: true,
      autoFocus: true,
      width: "calc(100vw - 32px)",
      maxWidth: "1320px",
      panelClass: ["custom-modalbox", "modal-tarea-anterior-dialog"],
      data: { tarea, idUsuario, fechaTarea, nombreProyecto },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDetalleProyeccion(this.data);
    });
  }
}
